import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BasicInfoService } from '../../../services/basic-info.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-initial-screen',
  templateUrl: './initial-screen.component.html',
  styleUrls: ['./initial-screen.component.scss'],
})
export class InitialScreenComponent {
  amount = new FormControl(1_000_000);
  time = new FormControl();
  constructor(
    private basicInfoService: BasicInfoService,
    private router: Router
  ) {}

  handleButtonClick(): void {
    this.basicInfoService.amount = this.amount.value;
    this.router.navigate(['/basic-info']);
  }
}
